export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://myroomsai.com').replace(/\/+$/, '');

export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/myroomsai-logo.png`;

export const ORGANIZATION_NAME = 'MyRoomsAI';
